module.exports = require("pica");